export default __webpack_public_path__ + "static/media/health_check_3x2_Cn.b0224ec7.webp";